<template>
  <div>
    <div v-if="customisation.layout === 0" class="w-screen">
      <Layout0Home />
    </div>

    <div v-if="customisation.layout === 1" class="w-screen">
      <Layout1Home />
    </div>

    <div v-if="customisation.layout === 2" class="w-screen">
      <Layout2Home />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Layout0Home from './Layout0/Home.vue'
import Layout1Home from './Layout1/Home.vue'
import Layout2Home from './Layout2/Home.vue'

export default {
  components: {
    Layout0Home,
    Layout1Home,
    Layout2Home,
  },

  computed: {
    ...mapGetters({
      customisation: 'careerwise/getCustomisation',
    }),
  },
}
</script>
